import { formatDateTime } from '@/lib/date';
import type { EmoviDocConversation } from './types';

export { formatDateTime as formatConversationDate };

export function formatConversationFallbackTitle(conversation: EmoviDocConversation | null): string {
  if (!conversation) return 'Conversazione';
  const dateValue = conversation.createdAt || conversation.lastMessageAt;
  if (!dateValue) return 'Conversazione';

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return 'Conversazione';

  const formattedDate = date.toLocaleDateString('it-IT', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  return `Conversazione del ${formattedDate}`;
}
